import {Box, Typography, useTheme} from "@mui/material";
import ScrollAnimation from "react-animate-on-scroll";
import {Element} from "react-scroll";

const Section = (props) => {
    const theme = useTheme();
    return <Element name={props.id}>
        <Box
            id={props.id}
            sx={{
                ...props.sx,
                px: props.noPadding ? 0 : 1,
                py: 5,
                textAlign: 'center',
                width: '100vw',
                backgroundColor: props.white ? '#fff' : theme.palette.brLight.main,
                boxSizing: 'border-box'
            }}>
            <Box sx={{ maxWidth: props.fullWidth ? 'auto' : {sm: '600px', md: '700px', xs: 'auto'}, margin: 'auto',}}>
                <ScrollAnimation animateIn='fadeIn'>
                    <Typography variant='h4' color='primary' mb={props.subtitle ? 1 : 3} sx={{textTransform: 'uppercase'}}>{props.title}</Typography>
                </ScrollAnimation>
                {props.subtitle && <ScrollAnimation animateIn='fadeIn' delay={100}>
                    <Typography variant='h6' color='secondary' mb={3}>{props.subtitle}</Typography>
                </ScrollAnimation>}
                {props.children}
            </Box>
        </Box>
    </Element>
}

export default Section;